"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function useTotalSelectedPages({ modulesList, modules, pages }) {
    let totalItemsSelected = 0;
    modules.forEach((selectedModuleItem) => {
        const module = modulesList.find((item) => item.id === selectedModuleItem);
        if (module) {
            totalItemsSelected += Number(module.totalPages);
        }
    });
    pages.forEach((selectedPageItem) => {
        const hasPageLoadedInModule = modulesList.some((item) => {
            var _a;
            return !modules.includes(item.id) &&
                ((_a = item.pages) === null || _a === void 0 ? void 0 : _a.some((pageItem) => pageItem.id === selectedPageItem));
        });
        if (hasPageLoadedInModule) {
            totalItemsSelected += 1;
        }
    });
    return totalItemsSelected;
}
exports.default = useTotalSelectedPages;
